import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "@/gen/tableNames/tables";

export type D1Issuer = {
  id: number;
  name: string;
  country: string;
  country_name: string;
  sector: string;
  created_at: string;
  updated_at: string;
};

const t = (key: string, defaultValue: string) =>
  i18n.t(`${Tables.D1_ISSUERS}.columns.${key}`, { ns: "tables", defaultValue });

export const issuers_columns: ColumnDef<D1Issuer>[] = [
  {
    accessorKey: "id",
    header: t("id", "ID"),
  },
  {
    accessorKey: "name",
    header: t("name", "Name"),
  },
  {
    accessorKey: "country_name",
    header: t("country_name", "Country"),
  },
  {
    accessorKey: "sector",
    header: t("sector", "Sector"),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex gap-3 justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
